import $ from "../libs/jquery-3.3.1.min.js"
import {BaseGameIngenium} from "./BaseGameIngenium";
import {AudioPlaylist} from './AudioPlaylist.js'
import {gsap} from "../libs/gsap/all.js"
import Swiper from "../libs/swiper.min"
import {PixiVideoPlayer} from "./PixiVideoPlayer.js";
import {Shutdown} from "./Shutdown.js";
import {Howl} from "howler";

const CHOICE_MODE = 2;
const EXPLANATION_MODE = 3;

// Constructor
export class RightDiet extends BaseGameIngenium {

	constructor() {

		// Super constructor
		super("data/right-diet.json");
		this.screensaverDelay = 25;
		// this.screensaverDelay = 1000000;

		this.playlist = new AudioPlaylist();

		this.locked = false;
		this.currentStepId = null;
		this.currentChoiceId = null;
		this.currentMode = null;

		this.currentTimeline = null;

		this.redirectTimeout = false;
	}

	// To be overriden in child games
	buildContent() {
		return new Promise((resolve, reject) => {
			// TODO build dom
			resolve();
		});
	}

	playAudioAmbiance() {
		// const sound = new Howl({
		// 	src: [this.data.audio.ambience],
		// 	loop: true,
		// 	autoplay: true,
		// 	volume: this.settings.volume.ambient_sound,
		// });
	}

	// To be overriden in child games
	initGame() {

		this.shutdown = new Shutdown(this.settings.shutdown_hold_delay_seconds);

		this.pixi = new PixiVideoPlayer();

		if (inElectron()) {
			this.playAudioAmbiance()
		} else {
			$(window).one('click', this.playAudioAmbiance());
		}

		this.initScreenSaver();
		this.goToScreen(1);
		// this.goToScreen(2);
		// this.goToScreen(3);

		// Go to first screen
		// if (inElectron()) {
		// this.initScreenSaver();
		// this.goToScreen(1);
		// } else {
		// 	$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
		// 	this.goToScreen("first-click-interact");
		// }

		// this.i18n.set("fr");

		this.tabsSwiper = new Swiper('.tabs', {
			direction: 'horizontal',
			slidesPerView: "auto",
			spaceBetween: 0,
			resistance: false,
			threshold: 15,
			loop: false,
			watchSlidesProgress: true,
			navigation: false,
		});

		// Play audio click
		$(".swiper-button-next, .swiper-button-prev").on("click", function () {
			this.playClickSound();
		}.bind(this));

		this.dietsSwiper = new Swiper('.diets', {
			direction: 'horizontal',
			loop: false,
			resistance: true,
			resistanceRatio: 0,
			slidesPerView: 1,
			threshold: 15,
			// effect: "cards",
			grabCursor: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

			thumbs: {
				swiper: this.tabsSwiper,
			},
		});

		this.dietsSwiper.on('slideChange', () => {
			console.log('slide changed');
			this.currentChoiceId = this.dietsSwiper.activeIndex;
		});
	};

	// To be overriden in child games
	initScreen(screenId) {

		// Super constructor
		if (super.initScreen(screenId) == false) {
			return false;
		}

		switch (screenId) {
			case 1:
				this.reset();
				break;
			case 2:
				break;
			case 4:
				this.currentMode = CHOICE_MODE;
				this.currentChoiceId = 0;
				this.tabsSwiper.slideTo(0, 0);
				this.dietsSwiper.slideTo(0, 0);
				break;
		}

		this.initScreenAudio(screenId);
	}

	// To be overriden in child games
	initScreenAudio(screenId) {
	}

	// To be overriden in child games
	onMessage(e) {
		var message = e.message;
		console.log("message received : ", message);

		if (this.lockScreen) {
			return;
		}

		this.resetTimer();
		this.playClickSound();

		if (this.stillThereTimeout != false) {
			this.closeStillThereModal();
			this.initScreenAudio(this.currentScreen);
			return;
		}

		// Global buttons
		switch (this.currentScreen) {
			case 1:
				if (message == this.buttons["english"]) {
					// English button
					this.requestedLanguage = "en";
					this.goToScreen(2);
				} else if (message == this.buttons["french"]) {
					// French button
					this.requestedLanguage = "fr";
					this.goToScreen(2);
				}
				break;
			default:
				if (message == this.buttons["english"]) {
					// English button
					this.i18n.setWithFlip("en");
					// this.initScreen(this.currentScreen);
				} else if (message == this.buttons["french"]) {
					// French button
					this.i18n.setWithFlip("fr");
					// this.initScreen(this.currentScreen);
				} else if (message == this.buttons["home"]) {
					// Home button
					this.reset(1);
				}
				break;
		}

		// Left, right and select butttons
		switch (this.currentScreen) {
			case 1:
				break;
			case 2:
				if (message == this.buttons["select"]) {
					this.goToScreen(3);
				}
				break;
			case 3:
				if (message == this.buttons["select"]) {
					this.goToScreen(4);
				}
				break;
			case 4:
				if (this.locked) {
					return;
				}
				if (message == this.buttons["select"]) {
					if (this.currentMode == CHOICE_MODE) {
						this.confirmChoice(this.currentChoiceId);
					} else {
						this.backToChoices();
					}
				} else if (message == this.buttons["left"]) {
					if (this.currentMode == CHOICE_MODE) {
						this.dietsSwiper.slidePrev();
					}
				} else if (message == this.buttons["right"]) {
					if (this.currentMode == CHOICE_MODE) {
						this.dietsSwiper.slideNext();
					}
				}
				break;
			// case 4:
			// 	if (message == this.buttons["select"]) {
			// 		this.reset(1);
			// 	}
			// 	break;
		}
	}

	playClickSound() {
		// Play audio click
		if (typeof this.settings.click_sound !== "undefined" && this.settings.click_sound != "") {
			this.audio.play(this.settings.click_sound, this.settings.volume.click);
		}
	}

	confirmChoice(choiceId) {
		this.currentChoiceId = choiceId;

		if (this.locked || this.currentChoiceId == null || this.dietsSwiper.animating) {
			return;
		}

		this.locked = true;
		this.currentMode = EXPLANATION_MODE;

		this.disableSlider();

		const dietEl = $("#screen-4 .diet").eq(this.currentChoiceId)
		const componentsEl = dietEl.find(".components");
		const confirmButtonEl = dietEl.find(".confirm-choice-button");
		const selectionInstructionEl = dietEl.find(".selection-instruction");
		const explanationEl = dietEl.find(".explanation")
		const nextButtonEl = explanationEl.find(".next-step-button");

		this.currentTimeline = gsap.timeline({
			onComplete: () => {
				this.locked = false;
			}
		});

		const videoAnim = this.data.content.diets[this.currentChoiceId].video_animation[this.i18n.lang]
		const videoLoop = this.data.content.diets[this.currentChoiceId].video_loop[this.i18n.lang]

		this.pixi.playNext(videoAnim, () => {
			this.currentTimeline.play()
		});
		this.pixi.playNext(videoLoop)

		this.currentTimeline.to([componentsEl, confirmButtonEl, selectionInstructionEl], {
			duration: 0.25,
			alpha: 0,
		}, 0);
		this.currentTimeline.fromTo(explanationEl, {
			autoAlpha: 0,
		}, {
			autoAlpha: 1,
			duration: 0.35,
		});

		// Video callback will unpause that
		this.currentTimeline.addPause();

		this.currentTimeline.fromTo(explanationEl.find(".spinning-loader"), {
			alpha: 1,
		}, {
			duration: 0.25,
			alpha: 0,
		});

		this.currentTimeline.add(() => {
			const choice = this.data.content.diets[this.currentChoiceId];
			console.log(choice)

			// Play sound
			if (choice.type == "failed") {
				this.audio.play(this.data.audio.wrong_answer, this.settings.volume.wrong_answer);
			} else if (choice.type == "success") {
				this.audio.play(this.data.audio.good_answer, this.settings.volume.good_answer);
			}
		});
		this.currentTimeline.fromTo([explanationEl.find(".text"), nextButtonEl], {
			autoAlpha: 0,
		}, {
			autoAlpha: 1,
		});
	}

	backToChoices() {

		if (this.locked) {
			return;
		}

		this.locked = true;
		this.currentMode = CHOICE_MODE;

		const dietEl = $("#screen-4 .diet").eq(this.currentChoiceId)
		const componentsEl = dietEl.find(".components");
		const confirmButtonEl = dietEl.find(".confirm-choice-button");
		const selectionInstructionEl = dietEl.find(".selection-instruction");
		const explanationEl = dietEl.find(".explanation")

		this.currentTimeline = gsap.timeline({
			onComplete: () => {
				this.locked = false;
			}
		});
		this.currentTimeline.to(explanationEl, {
			duration: 0.25,
			autoAlpha: 0,
		});
		this.currentTimeline.to([componentsEl, confirmButtonEl, selectionInstructionEl], {
			duration: 0.25,
			alpha: 1,
		});
		this.currentTimeline.add(() => {
			this.enableSlider();
		})

		// Play loop from question
		this.pixi.playNowWithFade(this.data.content.initial_video[this.i18n.lang])

	}

	enableSlider() {

		this.tabsSwiper.enable();
		this.dietsSwiper.enable();

		$(".swiper-button-next, .swiper-button-prev").removeClass("disabled");
	}

	disableSlider() {

		this.tabsSwiper.disable();
		this.dietsSwiper.disable();

		$(".swiper-button-next, .swiper-button-prev").addClass("disabled");
	}


	goToScreenSaver() {

		// Super constructor
		if (super.goToScreenSaver() == false) {
			return false;
		}
	}

	reset(screenId) {

		if (this.redirectTimeout != false) {
			clearTimeout(this.redirectTimeout);
			this.redirectTimeout = false;
		}

		if (this.currentTimeline) {
			this.currentTimeline.kill();
			this.currentTimeline = null;
		}

		let resetCallback = () => {
			this.locked = false;
			this.tabsSwiper.slideTo(0, 0);
			this.dietsSwiper.slideTo(0, 0);
			this.enableSlider();
		}

		this.locked = false;
		this.backToChoices();

		if (typeof screenId == "undefined") {
			resetCallback();
		}

		// Super
		if (super.reset(screenId, resetCallback) == false) {
			return false;
		}


	}
}